<template>
  <div class="message">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-9 col-md-10">
          <div class="write-area" v-if="user.id">
            <div class="input-group mb-3">
              <input type="text" class="form-control" placeholder="留言"
                @keyup.enter="submitMsg()" v-model="tempData.input">
              <div class="input-group-append">
                <button class="btn btn-outline-secondary"
                  type="button" @click="submitMsg()">
                  Button
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-9 col-md-10">
          <div class="content" v-for="(item, index) in messages" :key="index">
            <div class="pic" :style="{backgroundImage: 'url('+item.postUser.photoURL+')'}"></div>
            <div class="txt-area">
              <div class="con">
                <h4>{{ item.postUser.displayName }}</h4>
                <p>{{ item.content }}</p>
              </div>
              <a href="#" class="like" @click.prevent="likes(index)">
                <i class="far fa-thumbs-up"></i> {{ item.like | likes }}
              </a>
            </div>
            <div class="edit" v-if="item.postUser.email == user.data.email">
              <a href="#">
                <i class="fas fa-ellipsis-v"></i>
                <div class="con">
                  <a href="#">編輯</a>
                  <a href="#">刪除</a>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';

export default {
  props: ['user'],
  data() {
    return {
      tempData: {
        input: '',
      },
      messages: [],
    };
  },
  methods: {
    submitMsg() {
      const vm = this;
      firebase.database().ref('msg/').push().set({
        postUser: vm.user.data,
        content: vm.tempData.input,
        postTime: Math.floor(Date.now() / 1000),
        like: 0,
        enable: true,
      })
        .then(() => {
          vm.tempData.input = '';
        });
    },
    getMsgData() {
      const vm = this;
      firebase.database().ref('msg/').on('value', (snapshot) => {
        vm.messages = snapshot.val();
      });
    },
    likes(key) {
      const vm = this;
      const url = `msg/${key}/like/`;
      const likesNum = Object.keys(vm.messages[key].like)
        .map(i => [Number(i), vm.messages[key].like[i]]);
      if (vm.user.id) {
        if (vm.messages[key].like[vm.user.id]) {
          if (likesNum.length === 1) {
            firebase.database().ref(url).set(0);
          } else {
            firebase.database().ref(url + vm.user.id).remove();
          }
        } else {
          firebase.database().ref(url + vm.user.id).set({
            liked: true,
          });
        }
      }
    },
  },
  created() {
    this.getMsgData();
    // this.LoginOrNot()
  },
};
</script>

<style lang="scss" scoped>
  .message{
    padding: 80px 0;
    .write-area{
      padding: 10px 10px 5px 10px;
      background-color: #f6f6f6;
      border-radius: 5px;
    }
  }
  .content{
    display: flex;
    padding: 20px;
    border-bottom: 1px solid #aaa;
    .pic{
      flex: 0 1 80px;
      background-color: #f6f6f6;
      border: 5px solid #fff;
      box-shadow: 0 0 1px rgba(0,0,0,0.5);
      height: 80px;
      width: 100%;
      border-radius: 50%;
      background-size: cover;
      background-position: center center;
    }
    .txt-area{
      flex: 1;
      margin: 0 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .con{
        margin-bottom: 10px;
        h4{
          font-weight: bold;
          font-size: 16px;
          margin-bottom: 8px;
        }
      }
    }
    .like{
      &:hover{
        text-decoration: none;
      }
    }
    .edit{
      flex: 0 0 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      a{
        display: block;
        width: 100%;
        text-align: center;
        position: relative;
        &:hover{
          text-decoration: none;
        }
        .con{
          display: none;
        }
        &:focus{
          .con{
            display: block;
            position: absolute;
            padding: 5px 10px;
            background-color: #fff;
            border: 1px solid #aaa;
            top: calc(100% + 10px);
            left: 50%;
            transform: translateX(-50%);
            width: 70px;
            a{
              color: #333;
              border-top: 1px solid #aaa;
              padding: 5px;
              &:first-child{
                border: none;
              }
              &:hover{
                color: #2095f2;
              }
            }
          }
        }
      }
    }
  }
</style>
